import { useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  Chip,
  Grid,
  FormControl,
  InputLabel,
  ListItemText,
  Select,
  MenuItem
} from "@mui/material";
import { Settings } from "@mui/icons-material";
import { t } from "i18next";
import api from "../../../../../helpers/api/Api";
import ApiUrls from "../../../../../helpers/urls/ApiUrls";
import routes from "../../../../../routes";
import UserTypes from "../../../../../helpers/constants/UserTypes";
import { showStatus } from "../../../../../helpers/api/errors/ShowStatus";
import EditModal from "../../../../../components/EditModal";

function EditPermission({ user, handleCloseModal, disabled }) {
  const [newUser, setNewUser] = useState(user);
  const [modalOpen, setModalOpen] = useState(false);
  const [newPerms, setNewPerms] = useState([]);
  const [loading, setLoading] = useState(false);
  let userDefaultPerms = UserTypes[user?.type].defaultPermission;

  useEffect(() => {
    if (modalOpen) {
      setUserPerms();
      setNewUser({ ...user });
    } else {
      setNewPerms([]);
      setNewUser(null);
    }
  }, [modalOpen]);

  const setUserPerms = () => {
    const userPerms = user.perms;
    const userPermsObj = [];
    routes.map(({ permission, type }) =>
      userPerms & permission && (type === "menu_link" || type === "title") && userPermsObj.push(permission)
    );
    setNewPerms(userPermsObj);
  }

  const setFormPermissions = () => {
    let fp = 0;
    newPerms.map((perm) =>
      fp += perm
    );
    return fp;
  }

  const editUser = () => {
    setLoading(true);
    let postFormData = new FormData();
    postFormData.append('uid', newUser.id);
    postFormData.append('perms', setFormPermissions());

    const snackArgs = {
      item: t("user.permissions"),
      op: t("global.edit")
    };

    api.post(ApiUrls.user.edit, postFormData)
      .then((response) => {
        setLoading(false);
        setModalOpen(null);
        showStatus(response.data.status, snackArgs);
        if (response.data.status === "success") {
          handleCloseModal();
        }
      })
      .catch((error) => {
        setLoading(false);
        showStatus("error", snackArgs);
      });
  }

  const handleChange = (event) => {
    const { value } = event.target;
    setNewPerms(value);
  };

  return (
    <>
      {userDefaultPerms &&
        <EditModal
          title={t("user.permissions_edit")}
          onEdit={editUser}
          loading={loading}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          Icon={<Settings />}
          disabled={disabled}
        >
          <Grid item md={2} />
          <Grid item md={8}>
            {userDefaultPerms &&
              <FormControl fullWidth>
                <InputLabel id="permissions" shrink>{t("user.permissions")}</InputLabel>
                <Select
                  label={t("user.permissions")}
                  labelId="permissions"
                  id="permissions-select"
                  multiple
                  value={newPerms}
                  onChange={handleChange}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map((value) => (
                        <Chip key={value} color="info"
                              label={routes?.find(e => e.permission === value).name}
                        />
                      ))}
                    </Box>
                  )}
                >
                  {routes.map(({ permission, name, key, type }) => (
                    (userDefaultPerms & permission) && (type === "menu_link" || type === "title"))
                    ? (
                      <MenuItem key={key} value={permission} className="select-multiple">
                        <Checkbox checked={newPerms.includes(permission)} size="size" />
                        <ListItemText primary={name} />
                      </MenuItem>
                    )
                    : null
                  )}
                </Select>
              </FormControl>
            }
          </Grid>
          <Grid item md={2} />
        </EditModal>
      }
    </>
  )
}

export default EditPermission;
